module.exports = __webpack_public_path__ + "static/media/naice.e97e4cf9.jpg";